<template>
  <div class="navigate">
    <div class="navigate_main">
    <div class="logo">
      <div class="logo_2">
        <img src="../assets/img/ryb.png" />
      </div>
      <div class="logo_3">
        <span><div style="margin-left: -30px;">互联网+</div> <div>企业服务平台</div> </span>
      </div>
    </div>
    <div class="main">
      <el-menu
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#252a2f"
        text-color="#fff"
        active-text-color="#fff"
      >
        <el-menu-item index="1"
          ><a href="https://www.renyibao.com/" target="_blank"
            >企业服务</a
          ></el-menu-item
        >
        <el-menu-item index="2"
          ><a href="https://www.renyibao.com/" target="_blank"
            >政企通</a
          ></el-menu-item
        >
        <el-submenu index="3" :popper-append-to-body="false"
            popper-class="rsjwt">
          <template slot="title">人社局网厅</template>
           <div class="rsj">
          <el-menu-item index="3-1">
            <div>
              <ul style="margin-left: 10px;list-style-type: circle;">
                <el-col :span="2"
                  ><div class="grid-content bg-purple">
                    <li style="margin-left: 20px">市内六区</li>
                  </div></el-col
                >
                <el-col :span="6"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="6"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="6"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="4"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
              </ul>
              <el-row :gutter="40">
                <el-col :span="2"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://gov.renyibao.com/hrss/v2/home/index_bus.jsp?ssqx=heping#/gm"
                      target="_blank"
                      >和平区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://gov.renyibao.com/hrss/v2/home/index_bus.jsp?ssqx=hedong#/gm"
                      target="_blank"
                      >河东区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://wg.renyibao.com/rsj/index.jsp?ssqx=hexi"
                      target="_blank"
                      >河西区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://gov.renyibao.com/hrss/v2/home/index_bus.jsp?ssqx=nankai#/gm"
                      target="_blank"
                      >南开区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="2"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
              </el-row>
            </div>
            <div>
              <ul style="margin-left: 10px;list-style-type: circle;">
                <el-col :span="2"
                  ><div class="grid-content bg-purple">
                    <li style="margin-left: 20px">环城四区</li>
                  </div></el-col
                >
                <el-col :span="6"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="6"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="6"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="4"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
              </ul>
              <el-row :gutter="40">
                <el-col :span="2"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://gov.renyibao.com/hrss/v2/home/index_bus.jsp?ssqx=dongli#/gm"
                      target="_blank"
                      >东丽区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://gov.renyibao.com/hrss/v2/home/index_bus.jsp?ssqx=xiqing#/gm"
                      target="_blank"
                      >西青区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://gov.renyibao.com/hrss/v2/home/index_bus.jsp?ssqx=jinnan#/gm"
                      target="_blank"
                      >津南区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://gov.renyibao.com/hrss/v2/home/index_bus.jsp?ssqx=beichen#/gm"
                      target="_blank"
                      >北辰区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="2"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
              </el-row>
            </div>
            <div>
              <ul style="margin-left: 10px;list-style-type: circle;">
                <el-col :span="2"
                  ><div class="grid-content bg-purple">
                    <li style="margin-left: 20px">滨海新区</li>
                  </div></el-col
                >
                <el-col :span="6"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="6"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="6"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="4"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
              </ul>
              <el-row :gutter="40">
                <el-col :span="2"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="5"
                  ><div class="grid-content bg-purple" style="padding-left: 6px">
                    <a
                      href="https://wg.renyibao.com/rsj/index.jsp?ssqx=teda"
                      target="_blank"
                      >泰达开发区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://gov.renyibao.com/hrss/v2/gaoxin/home.jsp?ssqx=gaoxin#/120228"
                      target="_blank"
                      >高新区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://wg.renyibao.com/rsj/index.jsp?ssqx=dongjianggang"
                      target="_blank"
                      >东疆港人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple" style="padding-left: 6px">
                    <a
                      href="https://wg.renyibao.com/rsj/index.jsp?ssqx=shengtaicheng"
                      target="_blank"
                    >
                      中新生态城人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="2"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
              </el-row>
              <el-row :gutter="40">
                <el-col :span="2"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://wg.renyibao.com/rsj/index.jsp?ssqx=tanggu"
                      target="_blank"
                      >塘沽区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://wg.renyibao.com/rsj/index.jsp?ssqx=hangu"
                      target="_blank"
                      >汉沽区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://gov.renyibao.com/hrss/v2/home/index_bus.jsp?ssqx=dagang#/gm"
                      target="_blank"
                      >大港区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="2"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
              </el-row>
            </div>
            <div>
              <ul style="margin-left: 10px;list-style-type: circle;">
                <el-col :span="2"
                  ><div class="grid-content bg-purple">
                    <li style="margin-left: 20px">其他地区</li>
                  </div></el-col
                >
                <el-col :span="6"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="6"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="6"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="4"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
              </ul>
              <el-row :gutter="40">
                <el-col :span="2"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://wg.renyibao.com/rsj/index.jsp?ssqx=wuqing"
                      target="_blank"
                      >武清区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://gov.renyibao.com/hrss/v2/home/index_bus.jsp?ssqx=jinghai#/gm"
                      target="_blank"
                      >静海区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple">
                    <a
                      href="https://wg.renyibao.com/rsj/index.jsp?ssqx=ninghe"
                      target="_blank"
                      >宁河区人社局</a
                    >
                  </div></el-col
                >
                <el-col :span="5"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
                <el-col :span="2"
                  ><div class="grid-content bg-purple"></div
                ></el-col>
              </el-row>
            </div>
          </el-menu-item>
          </div>
        </el-submenu>
        <el-submenu index="4"   :popper-append-to-body="false"
            popper-class="syhhy">
          <template slot="title">胜云会会员</template>
          <el-menu-item index="4-1"
            ><a href="https://static.renyibao.com/qyhy/"
              >会员服务</a
            ></el-menu-item
          >
          <el-menu-item index="4-2"
            ><a
              href="https://static.renyibao.com/rspx/"
              target="_blank"
              >人事培训</a
            ></el-menu-item
          >
          <el-menu-item index="4-3"
            ><a
              href="https://static.renyibao.com/bx/"
              target="_blank"
              >保险服务</a
            ></el-menu-item
          >
          <el-menu-item index="4-4"
            ><a
              href="https://static.renyibao.com/tj/"
              target="_blank"
              >体检服务</a
            ></el-menu-item
          >
        </el-submenu>
        <el-menu-item index="5"
          ><a href="https://www.renyibao.com/about.jsp" target="_blank"
            >关于我们</a
          ></el-menu-item
        >
      </el-menu>
    </div>
    <div class="login">
      <el-menu
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#252a2f"
        text-color="#fff"
      >
        <el-menu-item index="1"
          ><a
            href="https://pass.renyibao.com/login.jsp?tourl=http%3A%2F%2Fwww.renyibao.com%2Fhome%2Findex.jsp#/uc"
            target="_blank"
            >登录</a
          ></el-menu-item
        >
        <el-menu-item index="1"
          ><a
            href="https://pass.renyibao.com/home/index.html#/reg"
            target="_blank"
            >注册</a
          ></el-menu-item
        >
        <el-menu-item index="1"
          ><a href="https://www.renyibao.com/help.jsp" target="_blank"
            >帮助</a
          ></el-menu-item
        >
      </el-menu>
    </div>
  </div>
   </div>
</template>

<script>
export default {
  name: "navigate",

  data() {
    return {
      // activeIndex2: '',
      // handleSelect:''
    };
  },
  methods: {
    handleSelect() {},
  },
};
</script>
<style >
.syhhy{
  width: 110px;
  top:56px !important;
   position: absolute !important;
  left: 288px !important;
}
.rsjwt{
  /* background: red; */
  top:56px !important;
   width: 649px;
   position: absolute !important;
  left: 178px !important;
}
.rsj{
  height: 390px;
    padding-top: 8px;
}
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 112px !important;
  text-align: center;
}
</style>
<style scoped>
 .el-submenu .el-menu-item{
  min-width: 110px !important;
}
.navigate {
  height: 60px;
  width: 100%;
  background: #252a2f;
  position: fixed;
  top: 0px;

  margin: auto;
}
.navigate_main {
  height: 60px;
  width: 1280px;
  /* background: #252a2f; */
  /* position: fixed; */
  top: 0px;
  margin: auto;
  text-align: center;
  margin: 0 auto;
}
.el-row {
  margin-bottom: 10px;
}

.grid-content {
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  /* background-color: #f9fafc; */
}
::v-deep .el-menu--horizontal > .el-menu-item {
  /* border-bottom: none; */
  color: #fff;
}
::v-deep.el-menu--horizontal > .el-menu-item {
  border-bottom: none;
}
::v-deep .el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
  color: #fff;
}
::v-deep.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none;
  color: #fff;
}
::v-deep.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  display: none;
}
::v-deep .el-menu.el-menu--horizontal {
  border-bottom: none;
}
::v-deep .el-submenu__icon-arrow .el-icon-arrow-down {
  display: none;
}

.logo {
  width: 625px;
  height: 60px;
  /* background: pink; */
  display: inline;
}
.main {
  width: 526px;
  height: 49px;
  margin-left: 333px;
  margin-top: -52px;
}

.login {
  width: 216px;
  height: 60px;

  /* float: left; */
 margin-left: 1029px;
  margin-top: -60px;
}

.logo_1 {
  /* background: red; */
  width: 346px;
  float: left;
  height: 60px;
}
.logo_2 {
  width: 150px;
  height: 60px;
  margin-left: 35px;
}
.logo_2 img {
  width: 130px;
  margin-top: -8px;
}
.logo_3 {
  width: 90px;
  font-size: 14px;
  color: #fff;
  font-weight: 600;
  margin-top: -47px;
  margin-left: 186px;
}
a {
  text-decoration: none;
  color: #fff;
}
</style>